<div class="d-flex justify-content-center align-items-center mt-5">
    <div class="bg-white p-4 login-div">
        <div class="d-flex justify-content-center mt-2 mb-3 fw-medium fs-4">
            {{ 'updatepassword' | translate }}
        </div>
        <form #passwordForm="ngForm" (ngSubmit)="updatePassword(passwordForm)">
            <div class="d-flex flex-column gap-2 mt-4">
                <p-password [(ngModel)]="oldPassword" name="oldPassword" [toggleMask]="true"
                    [placeholder]="'oldpassword' | translate" [feedback]="false" required #oldPwd="ngModel">
                </p-password>
                <small class="text-danger" *ngIf="oldPwd.invalid && oldPwd.touched">
                    {{'oldpasswordisrequired' | translate}}
                </small>
            </div>
            <div class="d-flex flex-column gap-2 mt-4">
                <p-password [(ngModel)]="newPassword" name="newPassword" [toggleMask]="true"
                    [placeholder]="'newpassword' | translate" [feedback]="false" required minlength="8"
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$" #newPwd="ngModel">
                </p-password>
                <small class="text-danger" *ngIf="newPwd.invalid && newPwd.touched">
                    {{'newpasswordisrequired' | translate}}
                    <span *ngIf="newPwd.errors?.required"></span>
                    <span *ngIf="newPwd.errors?.minlength"> {{'passwordmustbelong' | translate}}
                    </span>
                    {{'mustinclude' | translate}}
                    <span *ngIf="newPwd.errors?.pattern"></span>
                </small>
            </div>
            <div class="d-flex flex-column gap-2 mt-4">
                <p-password [(ngModel)]="confirmPassword" name="confirmPassword" [toggleMask]="true"
                    [placeholder]="'confirmpassword' | translate" required #confirmPwd="ngModel">
                </p-password>
                <small class="text-danger" *ngIf="confirmPwd.invalid && confirmPwd.touched">
                    {{'confirmpasswordisrequired' | translate}}

                </small>
                <small class="text-danger" *ngIf="confirmPassword !== newPassword && confirmPwd.touched">
                    {{'passworddonotmatch' | translate}}

                </small>
            </div>
            <div class="d-flex flex-column gap-2 mt-4 signin-div">
                <p-button [label]="'updatepassword' | translate" class="mybutton" type="submit">
                </p-button>
            </div>
        </form>
    </div>
</div>